import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
    //baseURL: `https://dw.consolidacion.complementservices.com/api/`,
    baseURL: `https://zentria.consolidation.complement-it.com/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
